import classNames from 'classnames';
import { useState } from 'react';
import capitaliseFirstLetter from '../../../../lib/utils/capitaliseFirstLetter';
import Button from '../../../Button';
import Item from './Item';

export default function Details({ title, attribute }) {
  const [isOpen, setIsOpen] = useState(false);

  const isGenres = title === 'genres';
  const isCast = title === 'cast';

  const wrapperClasses = classNames('text-sm');
  const paragraphClasses = classNames('w-full');
  const buttonWrapperClasses = classNames('a line');
  const detailsClasses = classNames('text-gray-500', {
    'w-10/12 line-clamp-4': !isOpen,
    'list-disc list-inside': !isGenres,
  });
  const itemWrapperClasses = classNames({
    'mb-2 last:mb-0': !isGenres,
    flex: isCast,
  });
  const Wrapper = isGenres ? 'p' : 'ul';
  const ItemWrapper = isGenres ? 'span' : 'li';
  return (
    <section className={wrapperClasses}>
      <section className="space-y-1">
        <h3 className="font-bold text-lg">{capitaliseFirstLetter(title)}:</h3>
        <section className="space-y-4">
          <section className={paragraphClasses}>
            <Wrapper className={detailsClasses}>
              {attribute.map((item, index) => {
                if (!isOpen && index > 4) {
                  return null;
                }
                return (
                  <ItemWrapper className={itemWrapperClasses} key={item.id}>
                    <Item key={item.id} item={item} showPhoto={isCast} />
                    {isGenres && (
                      <>
                        {index === 0 && attribute.length > 1 && ', '}
                        {index > 0 && attribute.length > index + 1 && ', '}
                      </>
                    )}
                  </ItemWrapper>
                );
              })}
            </Wrapper>
          </section>
          {attribute.length > 4 && (
            <Button
              variant="clear"
              className={buttonWrapperClasses}
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? 'See less' : 'See more'}
            </Button>
          )}
        </section>
      </section>
    </section>
  );
}
